// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3Uvnq","info":"UpdateTermsInfo_info__290E2"};